import Grid from "@material-ui/core/Grid";
import Link from "../../../components/Link";
import React from "react";
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './MoreThemes.css';

export default function MoreThemes({ moreThemes }) {
    useStyles(s);

    return (
        <div style={{ backgroundImage: 'linear-gradient(180deg, #f7f7f8, #fff)', textAlign: 'center', padding: '10px 0 20px 0' }}>
            <h2>More themes</h2>

            <Grid container alignContent={'center'} alignItems={'center'} justify={'center'} style={{ marginBottom: 20 }}>
                {moreThemes.map((theme, k) => (
                    <Grid item key={`more-themes-${k}`}>
                        <div className={s.card}>
                            <a href={'/theme/' + theme.id}>
                                <img src={`/screenshots/400/${theme.id}-${theme.workspace}.jpg`} width={200}/>
                            </a>

                            <h4 className={s.themeTitle}>
                                <a href={'/theme/' + theme.id}>{theme.title ? theme.title : 'No title'}</a>
                            </h4>
                        </div>
                    </Grid>
                ))}
            </Grid>

            <Link to={'/themes'}>Browse all new tab themes...</Link>
        </div>
    );
}